import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ProgramSummary from 'components/molecules/Program/ProgramSummary';
import { LayoutTriggerValueType } from 'defs/layout';
import { actionCreators as layoutAC } from 'store/layout';
import { CoachIsEnumType } from '../../../components/molecules/CoachSelector/CoachSelector';
import { getCoach } from '../../../store/profile';

export type ProgramSummaryDispatchPropsType = {
	doLockBody: (trigger?: LayoutTriggerValueType) => void;
	coach: CoachIsEnumType;
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doLockBody: layoutAC.doLockBody,
		},
		dispatch
	);
};

export const mapStateToProps = (state) => {
	return {
		coach: getCoach(state),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgramSummary as any);
